import { Box, SystemProps, Stack } from '@storyofams/react-ui';
import SbEditable from 'storyblok-react';

import { Heading } from '~components';

import { DynamicSectionContainer, RichText } from '..';

type TitleTextProps = {
  content: {
    title?: string;
    text: any;
    direction: string;
    button_link: any;
    button_label: string;
  };
  first?: boolean;
} & SystemProps;

export const TitleText = ({ content, first, ...props }: TitleTextProps) => {
  const startsWithBulletPoints =
    !!content?.text?.content?.[0]?.content?.[0]?.content?.[0]?.content[0]?.text;
  return (
    <SbEditable content={content as any}>
      <DynamicSectionContainer
        px={{
          all: 2,
          md: 10,
          lg:
            !!!content?.title || content?.direction === 'column' ? '280px' : 20,
        }}
        {...props}
      >
        <Stack
          space={
            !!!content?.title || content?.direction === 'column' ? 3 : [3, 6]
          }
          flexDirection={['column', content?.direction as any]}
          textAlign={
            content?.direction === 'column' && !!content?.title
              ? 'center'
              : 'left'
          }
        >
          {!!content?.title && (
            <Heading
              as={first ? 'h1' : 'h2'}
              variant="h2"
              width={['100%', content?.direction === 'column' ? '100%' : '50%']}
              color="#21857F"
            >
              {content?.title}
            </Heading>
          )}

          {(!!content?.text?.content?.[0]?.content?.[0]?.text ||
            startsWithBulletPoints) && (
            <Box
              width={[
                '100%',
                !!!content?.title || content?.direction === 'column'
                  ? '100%'
                  : '50%',
              ]}
            >
              {(!!content?.text?.content?.[0]?.content?.[0]?.text ||
                startsWithBulletPoints) && <RichText text={content?.text} color="#21857F" />}
            </Box>
          )}
        </Stack>
      </DynamicSectionContainer>
    </SbEditable>
  );
};
